import { memo, useCallback, useContext } from 'react';

import Price from '../../atoms/price';
import CoinName from '../../atoms/coinName';

import { exchangeColor } from '../../../constant/color';

import ThemeContext from '../../../context/theme';

interface ExchangeType {
  upbit: number;
  cobit: number;
  bithumb: number;
  name: string;
}

interface Props {
  key: string;
  exchange: ExchangeType;
  onClick: Function;
}

const Exchange = (props: Props) => {
  const theme = useContext(ThemeContext);

  const onClickHandler: any = useCallback(
    (coin: string) => props.onClick(props.exchange.name)
    ,[props.exchange.name]
  )

  return (
    <tr
      key={props.key}
      style={{
        display: "table",
        tableLayout: "fixed",
        width: "100%",
        color: theme.color.default
      }}
      onClick={onClickHandler}
    >
      <td style={{ fontSize: 13, borderBottom: `1px solid ${theme.borderColor.default}`, borderTop: `1px solid ${theme.borderColor.default}`, fontWeight: 900, textAlign: "center", padding: 3, width: "25%" }}>
        <CoinName value={props.exchange.name} />
      </td>
      <td style={{ fontSize: 13, borderBottom: `1px solid ${theme.borderColor.default}`, borderTop: `1px solid ${theme.borderColor.default}`, textAlign: "right", padding: 3, width: "25%" }}>
        <div style={{ color: exchangeColor.upbit, lineHeight: 1.5, boxSizing: "border-box", padding: 10, width: '100%', height: "100%" }}>
          <Price value={props.exchange.upbit} timestamp={new Date().getTime()} />
        </div>
      </td>
      <td style={{ color: exchangeColor.bithumb, fontSize: 13, borderBottom: `1px solid ${theme.borderColor.default}`, borderTop: `1px solid ${theme.borderColor.default}`, textAlign: "right", padding: 3, width: "25%" }}>
        <Price value={props.exchange.bithumb} timestamp={new Date().getTime()} />
      </td>
      <td style={{ fontSize: 13, color:exchangeColor.cobit, borderBottom: `1px solid ${theme.borderColor.default}`, borderTop: `1px solid ${theme.borderColor.default}`, textAlign: "right", padding: 3, width: "25%" }}>
        <Price value={props.exchange.cobit} timestamp={new Date().getTime()} />
      </td>
    </tr>
  );
};

export default memo(Exchange);
